import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, Transition as _Transition, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-col items-center justify-center w-full mx-auto space-y-4",
  style: {"height":"88%"}
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-8 text-2xl font-regular mx-auto text-center" }, " Studiare è più semplice con Evo Learning AI Tutor ", -1)
const _hoisted_4 = { class: "text-lg flex flex-col space-y-6 md:w-4/5 md:mx-auto mx-2" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<li class=\"flex items-center md:space-x-6 space-x-4\"><div class=\"w-10 h-10 p-2 rounded-full chip-primary\"><i class=\"material-icons\">mic</i></div><p><strong class=\"font-medium\"> Chiedi tutto ciò che vuoi </strong>– Parla con il tutor come faresti con un docente: poni domande, chiarisci dubbi e approfondisci i concetti a voce. </p></li><li class=\"flex items-center md:space-x-6 space-x-4\"><div class=\"w-10 h-10 p-2 rounded-full chip-primary\"><i class=\"material-icons\">book</i></div><p><strong class=\"font-medium\"> Studia con materiali interattivi </strong>– Slide, immagini, formule, esempi pratici e codice ti aiuteranno a comprendere meglio ogni lezione. </p></li><li class=\"flex items-center md:space-x-6 space-x-4\"><div class=\"w-10 h-10 p-2 rounded-full chip-primary\"><i class=\"material-icons\">assignment</i></div><p><strong class=\"font-medium\"> Esercitati in tempo reale </strong>– Accedi a migliaia di esercizie risolvili insieme al tutor. </p></li><li class=\"flex items-center md:space-x-6 space-x-4\"><div class=\"w-10 h-10 p-2 rounded-full chip-primary\"><i class=\"material-icons\">code</i></div><p><strong class=\"font-medium\"> Programma insieme al tutor </strong>– Lavora in modalità pair programming con suggerimenti, correzioni e aiuto diretto sul codice. </p></li>", 4)
const _hoisted_9 = { class: "flex items-center md:space-x-6 space-x-4" }
const _hoisted_10 = { class: "w-10 h-10 py-1 px-2 rounded-full chip-primary" }
const _hoisted_11 = {
  style: {"fill":"currentColor","width":"25px"},
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("title", null, "draw", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", { d: "M9.75 20.85C11.53 20.15 11.14 18.22 10.24 17C9.35 15.75 8.12 14.89 6.88 14.06C6 13.5 5.19 12.8 4.54 12C4.26 11.67 3.69 11.06 4.27 10.94C4.86 10.82 5.88 11.4 6.4 11.62C7.31 12 8.21 12.44 9.05 12.96L10.06 11.26C8.5 10.23 6.5 9.32 4.64 9.05C3.58 8.89 2.46 9.11 2.1 10.26C1.78 11.25 2.29 12.25 2.87 13.03C4.24 14.86 6.37 15.74 7.96 17.32C8.3 17.65 8.71 18.04 8.91 18.5C9.12 18.94 9.07 18.97 8.6 18.97C7.36 18.97 5.81 18 4.8 17.36L3.79 19.06C5.32 20 7.88 21.47 9.75 20.85M20.84 5.25C21.06 5.03 21.06 4.67 20.84 4.46L19.54 3.16C19.33 2.95 18.97 2.95 18.76 3.16L17.74 4.18L19.82 6.26M11 10.92V13H13.08L19.23 6.85L17.15 4.77L11 10.92Z" }, null, -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", { class: "font-medium" }, " Scrivi sulla lavagna digitale "),
  /*#__PURE__*/_createTextVNode("– Simula algoritmi, risolvi equazioni e ricevi feedback immediato grazie al riconoscimento intelligente della scrittura. ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "mt-6 text-muted mx-auto" }, " Pronto per iniziare? Scegli l’argomento, accendi il microfono, e comincia la tua sessione con Evo Learning AI Tutor. ", -1)
const _hoisted_17 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_18 = { class: "font-semibold text-primary" }
const _hoisted_19 = {
  key: 1,
  class: "ml-0 text-muted"
}
const _hoisted_20 = { class: "font-semibold text-primary" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Confermi di voler iniziare la sessione?", -1)
const _hoisted_22 = {
  key: 0,
  class: "mt-8 banner banner-light align-start"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined inline-icon text-muted opacity-70",
  style: {"font-size":"24px !important"}
}, " info ", -1)
const _hoisted_24 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_25 = { class: "font-semibold text-primary" }
const _hoisted_26 = {
  key: 1,
  class: "ml-0 text-muted"
}
const _hoisted_27 = { class: "font-semibold text-primary" }
const _hoisted_28 = {
  key: 1,
  class: "flex md:flex-row items-start w-full h-full md:space-x-6 space-y-4 md:space-y-0 flex-col"
}
const _hoisted_29 = { class: "flex flex-col items-center md:w-1/5 w-full h-full py-6 px-6 space-y-8 rounded-lg bg-gray-50 order-1 md:order-0" }
const _hoisted_30 = { class: "flex items-center w-full justify-between place-content-between space-x-2" }
const _hoisted_31 = { class: "flex items-center space-x-2" }
const _hoisted_32 = { class: "flex items-center space-x-2" }
const _hoisted_33 = {
  key: 0,
  style: {"width":"2.4rem","height":"2.4rem"},
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28"
}
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<path d=\"M18,22A2,2 0 0,0 20,20V4C20,2.89 19.1,2 18,2H12V9L9.5,7.5L7,9V2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18Z\" fill=\"#6A16F0\" opacity=\"1\"><animate attributeName=\"opacity\" values=\"1;0.92;1\" dur=\"2s\" repeatCount=\"indefinite\"></animate><animate attributeName=\"fill\" values=\"#6A16F0;#c792fc;#6A16F0\" dur=\"2s\" repeatCount=\"indefinite\"></animate></path><g id=\"dots\"><circle cx=\"8\" cy=\"25\" r=\"1\" fill=\"#5611C4\" transform-origin=\"8 23\"><animateTransform attributeName=\"transform\" type=\"scale\" values=\"1;1.5;1\" begin=\"0s\" dur=\"1.2s\" repeatCount=\"indefinite\"></animateTransform><animate attributeName=\"fill\" values=\"#5611C4;#c792fc;#5611C4\" begin=\"0s\" dur=\"1.2s\" repeatCount=\"indefinite\"></animate></circle><circle cx=\"12\" cy=\"25\" r=\"1\" fill=\"#5611C4\" transform-origin=\"12 23\"><animateTransform attributeName=\"transform\" type=\"scale\" values=\"1;1.5;1\" begin=\"0.2s\" dur=\"1.2s\" repeatCount=\"indefinite\"></animateTransform><animate attributeName=\"fill\" values=\"#5611C4;#c792fc;#5611C4\" begin=\"0.2s\" dur=\"1.2s\" repeatCount=\"indefinite\"></animate></circle><circle cx=\"16\" cy=\"25\" r=\"1\" fill=\"#5611C4\" transform-origin=\"16 23\"><animateTransform attributeName=\"transform\" type=\"scale\" values=\"1;1.5;1\" begin=\"0.4s\" dur=\"1.2s\" repeatCount=\"indefinite\"></animateTransform><animate attributeName=\"fill\" values=\"#5611C4;#c792fc;#5611C4\" begin=\"0.4s\" dur=\"1.2s\" repeatCount=\"indefinite\"></animate></circle></g>", 2)
const _hoisted_36 = [
  _hoisted_34
]
const _hoisted_37 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"2.4rem","height":"2.4rem"},
  viewBox: "0 0 24 26"
}
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<path d=\"M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z\" fill=\"#5611C4\" opacity=\"1\"><animate attributeName=\"opacity\" values=\"1;0.9;1\" dur=\"2s\" repeatCount=\"indefinite\"></animate><animate attributeName=\"fill\" values=\"#5611C4;#EEDCFF;#5611C4\" dur=\"2s\" repeatCount=\"indefinite\"></animate></path><circle cx=\"8\" cy=\"23\" r=\"1\" fill=\"#5611C4\" transform-origin=\"8 23\"><animateTransform attributeName=\"transform\" type=\"scale\" values=\"1;1.5;1\" begin=\"0s\" dur=\"1.2s\" repeatCount=\"indefinite\"></animateTransform><animate attributeName=\"fill\" values=\"#5611C4;#EEDCFF;#F2F2F3;#5611C4\" begin=\"0s\" dur=\"1.2s\" repeatCount=\"indefinite\"></animate></circle><circle cx=\"12\" cy=\"23\" r=\"1\" fill=\"#5611C4\" transform-origin=\"12 23\"><animateTransform attributeName=\"transform\" type=\"scale\" values=\"1;1.5;1\" begin=\"0.2s\" dur=\"1.2s\" repeatCount=\"indefinite\"></animateTransform><animate attributeName=\"fill\" values=\"#5611C4;#EEDCFF;#F2F2F3;#5611C4\" begin=\"0.2s\" dur=\"1.2s\" repeatCount=\"indefinite\"></animate></circle><circle cx=\"16\" cy=\"23\" r=\"1\" fill=\"#5611C4\" transform-origin=\"16 23\"><animateTransform attributeName=\"transform\" type=\"scale\" values=\"1;1.5;1\" begin=\"0.4s\" dur=\"1.2s\" repeatCount=\"indefinite\"></animateTransform><animate attributeName=\"fill\" values=\"#5611C4;#EEDCFF;#F2F2F3;#5611C4\" begin=\"0.4s\" dur=\"1.2s\" repeatCount=\"indefinite\"></animate></circle>", 4)
const _hoisted_42 = [
  _hoisted_38
]
const _hoisted_43 = {
  style: {"stroke":"transparent","fill":"#6a16f0"},
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("title", null, "human-male-board", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("path", { d: "M20,17A2,2 0 0,0 22,15V4A2,2 0 0,0 20,2H9.46C9.81,2.61 10,3.3 10,4H20V15H11V17M15,7V9H9V22H7V16H5V22H3V14H1.5V9A2,2 0 0,1 3.5,7H15M8,4A2,2 0 0,1 6,6A2,2 0 0,1 4,4A2,2 0 0,1 6,2A2,2 0 0,1 8,4Z" }, null, -1)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  class: "overflow-y-auto w-full flex flex-col space-y-2",
  style: {"max-height":"23rem"}
}
const _hoisted_48 = {
  class: "flex flex-col space-y-4",
  style: {"margin-top":"-0.2rem"}
}
const _hoisted_49 = { class: "flex flex-wrap space-x-1 items-center" }
const _hoisted_50 = {
  key: 0,
  class: "material-icons-outlined"
}
const _hoisted_51 = {
  key: 1,
  class: "material-icons-outlined"
}
const _hoisted_52 = {
  key: 2,
  class: "material-icons-outlined"
}
const _hoisted_53 = {
  key: 3,
  class: "text-muted"
}
const _hoisted_54 = { class: "flex flex-col items-center w-full h-full space-y-4 order-0 md:order-1" }
const _hoisted_55 = { class: "flex w-full h-full overflow-auto relative" }
const _hoisted_56 = {
  key: 0,
  class: "absolute top-0 left-0"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Vai alla lezione", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined ml-0.5 inline-icon",
  style: {"font-size":"15px !important"}
}, " open_in_new ", -1)
const _hoisted_59 = [
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = {
  class: "flex flex-col m-auto",
  style: {"max-height":"500px"}
}
const _hoisted_61 = {
  key: 1,
  style: {"max-width":"700px"},
  class: "w-full flex flex-col ml-8 space-y-2"
}
const _hoisted_62 = { class: "opacity-70" }
const _hoisted_63 = {
  key: 2,
  class: "w-full flex flex-col ml-8 space-y-2"
}
const _hoisted_64 = { class: "opacity-70" }
const _hoisted_65 = {
  key: 0,
  style: {"max-width":"700px"},
  class: "flex flex-col space-y-4"
}
const _hoisted_66 = {
  key: 3,
  class: "flex flex-col items-center"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "mx-auto material-icons-outlined opacity-10"
}, " book ", -1)
const _hoisted_68 = { class: "mx-auto opacity-40" }
const _hoisted_69 = {
  key: 4,
  class: "flex items-center align-center"
}
const _hoisted_70 = {
  style: {"width":"12rem","height":"12rem"},
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18,22A2,2 0 0,0 20,20V4C20,2.89 19.1,2 18,2H12V9L9.5,7.5L7,9V2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18Z",
  fill: "#6A16F0",
  opacity: "1"
}, [
  /*#__PURE__*/_createElementVNode("animate", {
    attributeName: "opacity",
    values: "1;0.92;1",
    dur: "2s",
    repeatCount: "indefinite"
  }),
  /*#__PURE__*/_createElementVNode("animate", {
    attributeName: "fill",
    values: "#6A16F0;#c792fc;#6A16F0",
    dur: "2s",
    repeatCount: "indefinite"
  })
], -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("g", { id: "dots" }, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "8",
    cy: "25",
    r: "1",
    fill: "#5611C4",
    "transform-origin": "8 23"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      type: "scale",
      values: "1;1.5;1",
      begin: "0s",
      dur: "1.2s",
      repeatCount: "indefinite"
    }),
    /*#__PURE__*/_createElementVNode("animate", {
      attributeName: "fill",
      values: "#5611C4;#c792fc;#5611C4",
      begin: "0s",
      dur: "1.2s",
      repeatCount: "indefinite"
    })
  ]),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "25",
    r: "1",
    fill: "#5611C4",
    "transform-origin": "12 23"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      type: "scale",
      values: "1;1.5;1",
      begin: "0.2s",
      dur: "1.2s",
      repeatCount: "indefinite"
    }),
    /*#__PURE__*/_createElementVNode("animate", {
      attributeName: "fill",
      values: "#5611C4;#c792fc;#5611C4",
      begin: "0.2s",
      dur: "1.2s",
      repeatCount: "indefinite"
    })
  ]),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "16",
    cy: "25",
    r: "1",
    fill: "#5611C4",
    "transform-origin": "16 23"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      type: "scale",
      values: "1;1.5;1",
      begin: "0.4s",
      dur: "1.2s",
      repeatCount: "indefinite"
    }),
    /*#__PURE__*/_createElementVNode("animate", {
      attributeName: "fill",
      values: "#5611C4;#c792fc;#5611C4",
      begin: "0.4s",
      dur: "1.2s",
      repeatCount: "indefinite"
    })
  ])
], -1)
const _hoisted_73 = [
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = {
  key: 0,
  class: "w-full h-full"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 mr-1 text-base material-icons" }, " play_arrow ", -1)
const _hoisted_76 = {
  key: 0,
  class: "opacity-50"
}
const _hoisted_77 = {
  key: 1,
  class: "opacity-0"
}
const _hoisted_78 = { key: 2 }
const _hoisted_79 = {
  key: 0,
  class: "text-sm text-muted",
  style: {"margin-bottom":"-5px"}
}
const _hoisted_80 = {
  key: 0,
  style: {"font-size":"18px !important"},
  class: "material-icons-outlined text-danger"
}
const _hoisted_81 = {
  key: 1,
  style: {"font-size":"18px !important"},
  class: "material-icons-outlined text-yellow-500"
}
const _hoisted_82 = {
  key: 2,
  style: {"font-size":"18px !important"},
  class: "material-icons-outlined opacity-30"
}
const _hoisted_83 = { style: {"line-height":"0.75"} }
const _hoisted_84 = {
  key: 0,
  class: "absolute bottom-0 right-0 z-50 flex items-center px-6 py-3 mb-2 mr-4 space-x-2 rounded bg-dark text-lightText bg-opacity-90 shadow-popup"
}
const _hoisted_85 = { class: "w-full h-full" }
const _hoisted_86 = {
  key: 2,
  class: "flex items-center justify-between w-full px-4 py-2 mt-auto rounded bg-gray-50"
}
const _hoisted_87 = { class: "flex items-center space-x-2" }
const _hoisted_88 = { class: "transition-transform duration-200 ease-out transform material-icons-outlined" }
const _hoisted_89 = { class: "text-xs text-muted" }
const _hoisted_90 = { class: "flex items-center md:space-x-6 space-x-4" }

import axios from "axios";
import { reactive, ref, shallowRef, getCurrentInstance } from "vue";
import { onMounted, onBeforeUnmount } from "vue";
import { computed } from "vue";

import { useRoute, useRouter } from "vue-router";
import MicTalking from "../../components/shared/MicTalking.vue";
import Avatar from "../../components/ui/Avatar.vue";
import { useMetaStore } from "@/stores/metaStore";
import { useMainStore } from "@/stores/mainStore";
import Card from "../../components/ui/Card.vue";
import Btn from "../../components/ui/Btn.vue";
import { watch } from "vue";
import ProcessedTextFragment from "../../components/ui/ProcessedTextFragment.vue";
import { setErrorNotification } from "../../utils";
import { getTranslatedString as _ } from "../../i18n";
import Countdown from "../../components/ui/Countdown.vue";
import CodeEditor from "../../components/ui/CodeEditor.vue";
import Tabs from "../../components/ui/Tabs.vue";
import IntegratedFileViewer from "../../components/file_viewers/IntegratedFileViewer.vue";
import DrawEditor from "../../components/ui/DrawEditor.vue";
import { debounce } from "lodash";
import Exercise from "../../components/shared/Exercise/Exercise.vue";
import ClozeExercise from "../../components/shared/Exercise/ClozeExercise.vue";
import { EventSourcePolyfill as EventSource } from "event-source-polyfill";
import {
	EventParticipationSlotSubmission,
	ExerciseType,
	getEmptySubmission,
	getFakeEventParticipationSlot,
} from "../../models";
import { updateExercise } from "../../api";
import CodeExecutionResults from "../../components/shared/CodeExecutionResults.vue";
import { v4 as uuidv4 } from "uuid";
import Timeline from "../../components/ui/Timeline.vue";
import { nextTick } from "vue";
import * as monaco from "monaco-editor";
import Spinner from "../../components/ui/Spinner.vue";
import { drawText } from "../../whiteboard";
import { parseMermaidToExcalidraw } from "@excalidraw/mermaid-to-excalidraw";
import { convertToExcalidrawElements } from "@excalidraw/excalidraw";
import { ExcalidrawElementSkeleton } from "@excalidraw/excalidraw/types/data/transform";
import Dialog from "../../components/ui/Dialog.vue";
import WaveAnimation from "../../components/ui/WaveAnimation.vue";

type CellCoordinates = {
	x: number; // top-left x
	y: number; // top-left y
	width: number;
	height: number;
};
type ConversationStep = {
	id: string;
	title: string;
	summary: string;
	material_ids: string[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'RealtimeTutor',
  props: {
    courseIdOverride: null
  },
  setup(__props: any) {

const props = __props as { courseIdOverride?: string };

/* eslint-disable no-case-declarations */


/** --- misc --- */

const tabs = ref([
	{
		value: "material",
		// icons: ["people"],
		content: "Materiale", //_("course_insights.enrolled_students"),
	},
	{
		value: "code",
		// icons: ["table_chart"],
		content: "Codice", //_("course_insights.exams_stats"),
	},
	{
		value: "whiteboard",
		content: "Lavagna", //_("course_insights.exams_stats"),
	},
]);
const currentTab = ref(tabs.value[0].value);

const metaStore = useMetaStore();

const router = useRouter();

const openApiRealtimeBaseUrl = "https://api.openai.com/v1/realtime";

const runCountDown = ref(false);

const timeLimitSeconds = ref<number | null>(null);
const endTimestamp = computed(() => {
	if (!timeLimitSeconds.value) {
		return null;
	}
	const now = new Date();
	const endTime = new Date(now.getTime() + timeLimitSeconds.value * 1000);
	return endTime.getTime();
});
const rateLimit = ref<string | null>(null);
const rateLimitParsed = computed(() => {
	if (!rateLimit.value) {
		return null;
	}
	return rateLimit.value.split("/");
});

const route = useRoute();
const courseId = computed(() => props.courseIdOverride ?? route.params.courseId);

const userTalking = ref(false);
const assistantTalking = ref(false);
const showStartInstructions = ref(false);
const showStartDialog = ref(false);

const pc = ref<RTCPeerConnection | null>(null);
const dataChannel = ref<RTCDataChannel | null>(null);
const audioStream = ref<MediaStream | null>(null);
const tracks = ref<RTCRtpSender[] | null>(null);

const sessionId = ref<string | null>(null);

const sendClientEvent = (event: any) => {
	console.log("Sending event:", event);
	if (!dataChannel.value) {
		console.error("Data channel is not initialized");
		return;
	}
	dataChannel.value.send(JSON.stringify(event));
};

const beforeWindowUnload = (e: { preventDefault: () => void; returnValue: string }) => {
	if (
		(sessionState.value === "active" || sessionState.value === "starting") &&
		!window.confirm(_("misc.confirm_exiting_unsaved_changes"))
	) {
		// Cancel the event
		e.preventDefault();
		// Chrome requires returnValue to be set
		e.returnValue = "";
	}
};

const sessionData = ref({
	errors: [] as string[],
	debug: [] as any[],
	logs: [] as { role: "user" | "assistant"; content: any; timestamp: string }[],
});
// periodically push session data when it changes
const pushSessionData = debounce(() => {
	if (!sessionId.value) {
		return;
	}
	axios.put(`/integrations/tutor/session_data/`, {
		session_id: sessionId.value,
		data: sessionData.value,
	});
}, 2500);
watch(sessionData, pushSessionData, { deep: true });

const sessionState = ref<"init" | "starting" | "active" | "ended">("init");

onBeforeUnmount(() => {
	window.removeEventListener("beforeunload", beforeWindowUnload);
	endSession();
});

/** --- mic --- */
const isListening = ref(false);

const hasMicPermission = ref(false);
const getMicPermission = async () => {
	try {
		const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
		stream.getTracks().forEach(track => track.stop());
		const granted = await navigator.permissions
			.query({ name: "microphone" })
			.then(({ state }) => state === "granted");
		hasMicPermission.value = granted;
	} catch (e) {
		console.error(e);
		hasMicPermission.value = false;
	}
};

// Grabs a new mic track and replaces the placeholder track in the transceiver
const startRecording = async () => {
	try {
		const newStream = await navigator.mediaDevices.getUserMedia({
			audio: true,
		});
		audioStream.value = newStream;

		// If we already have an audioSender, just replace its track:
		if (tracks.value) {
			const micTrack = newStream.getAudioTracks()[0];
			tracks.value.forEach(sender => {
				sender.replaceTrack(micTrack);
			});
		} else if (pc.value) {
			// Fallback if audioSender somehow didn't get set
			newStream.getTracks().forEach(track => {
				const sender = pc.value?.addTrack(track, newStream);
				if (sender) {
					tracks.value = [...(tracks.value || []), sender];
				}
			});
		}

		isListening.value = true;
		console.log("Microphone started.");
	} catch (error) {
		console.error("Error accessing microphone:", error);
	}
};

// Replaces the mic track with a placeholder track
const stopRecording = () => {
	isListening.value = false;

	if (userTalking.value) {
		userTalking.value = false;
		sendClientEvent({ type: "input_audio_buffer.commit" });
		sendClientEvent({ type: "response.create" });
	}

	// Stop existing mic tracks so the user's mic is off
	if (audioStream.value) {
		audioStream.value.getTracks().forEach(track => track.stop());
	}
	audioStream.value = null;

	// Replace with a placeholder (silent) track
	if (tracks.value) {
		const placeholderTrack = createEmptyAudioTrack();
		tracks.value.forEach(sender => {
			sender.replaceTrack(placeholderTrack);
		});
	}
};

const createEmptyAudioTrack = (): MediaStreamTrack => {
	const audioContext = new AudioContext();
	const destination = audioContext.createMediaStreamDestination();
	return destination.stream.getAudioTracks()[0];
};

const whiteboardDiagrams = ref({});

/** --- handlers --- */

const callIdToFunctionName = ref<Record<string, string>>({});
const pendingFunctions = ref<Record<string, boolean>>({});
const reloadingExercise = ref(false);

const localFns = {
	// session management
	start_step: {
		done: async ({ title, summary }) => {
			conversationSteps.value.unshift({
				id: uuidv4(),
				title,
				summary,
				material_ids: [],
			});

			console.log("Step started", conversationSteps.value);
		},
	},
	end_session: {
		done: async () => {
			endSession();
		},
	},
	// material items
	show_material: {
		done: async ({ url, page_number }) => {
			const newItem = {
				id: uuidv4(),
				type: "material",
				url: url,
				page: page_number,
			};
			materialItems.value.unshift(newItem as any);
			currentTab.value = "material";
			currentConversationStep.value?.material_ids?.push(newItem.id);
			materialItemCursor.value = 0;
		},
	},
	show_exercise: {
		done: async ({ exercise_id }) => {
			const exercise = fetchedExercises.value.find(e => e.id == exercise_id);
			if (!exercise) {
				return {
					hint: "Errore: non usare ID inventati. Chiama nuovamente questa funzione con l'ID di un esercizio restituito da una chiamata precedente a get_exercises_by_keywords",
				};
			}

			const typeMap = {
				radio_choice: () => ExerciseType.MULTIPLE_CHOICE_SINGLE_POSSIBLE,
				checkbox_choice: () => ExerciseType.MULTIPLE_CHOICE_MULTIPLE_POSSIBLE,
				code: (lang: string) =>
					lang.toLowerCase() === "javascript" || lang.toLowerCase() === "typescript"
						? ExerciseType.JS
						: lang.toLowerCase() === "python"
						? ExerciseType.PYTHON
						: ExerciseType.C,
				text: () => ExerciseType.OPEN_ANSWER,
				cloze: () => ExerciseType.COMPLETION,
			};

			const formattedExercise = {
				...exercise,
				exercise_type: (typeMap[exercise.type] || (() => ExerciseType.OPEN_ANSWER))(
					exercise.language,
				),
			};
			const slot = getFakeEventParticipationSlot(formattedExercise);

			// ! hacky
			// generate ids for newItem slot and sub_slots - random number between 1 and 1_000_000
			slot.id = Math.floor(Math.random() * 1000000);
			slot.sub_slots = slot.sub_slots.map(subSlot => ({
				...subSlot,
				id: Math.floor(Math.random() * 1000000),
			}));

			const newItem = {
				id: uuidv4(),
				type: "exercise",
				exercise: formattedExercise,
				submission: getEmptySubmission(),
				slot,
			};

			materialItems.value.unshift(newItem as any);
			currentTab.value = exercise.type === "code" ? "code" : "material";
			currentConversationStep.value?.material_ids?.push(newItem.id);
			materialItemCursor.value = 0;

			playgroundExecutionResults.value = [];
			// ! TODO this hack is due to the fact that the checkboxes and radios don't update properly - fix
			reloadingExercise.value = true;
			nextTick(() => {
				reloadingExercise.value = false;
			});

			setTimeout(() => triggerTexRender(), 1000);
		},
	},
	show_example: {
		start: async ({ call_id }) => {
			const newItem = {
				id: uuidv4(),
				type: "example",
				text: "",
				call_id,
				raw_data: "",
			};
			materialItems.value.unshift(newItem as any);
			currentTab.value = "material";
			currentConversationStep.value?.material_ids?.push(newItem.id);
			materialItemCursor.value = 0;
		},
		delta: async ({ delta, call_id }) => {
			/* -------------------------------------------------
			 * helpers
			 * ------------------------------------------------- */

			// 1. keep the old back&ndash;tick fixer
			function fixUnclosedCodeBlock(text: string) {
				const first = text.indexOf("```");
				if (first === -1) return text;

				const closing = text.indexOf("```", first + 3);
				return closing === -1 ? text + "\n```" : text;
			}

			// 2. NEW ➜ hide a trailing, still-open HTML tag
			function stripTrailingOpenHtml(text: string) {
				/*  - Find the last “<”.
				 *  - If there is no “>” after it we are still inside the tag,
				 *    so everything from that “<” to the end of the string
				 *    gets removed for now.
				 *  - We **do not** touch “<” that live inside an open ``` code block.
				 */
				const lastOpen = text.lastIndexOf("<");
				if (lastOpen === -1) return text;

				// ignore < inside an unfinished code block
				const lastBacktick = text.lastIndexOf("```");
				const insideOpenCodeBlock =
					lastBacktick !== -1 && text.indexOf("```", lastBacktick + 3) === -1;

				if (insideOpenCodeBlock && lastOpen > lastBacktick) return text;

				if (text.indexOf(">", lastOpen) === -1) {
					return text.slice(0, lastOpen);
				}
				return text;
			}

			function postProcess(text: string) {
				// order matters: first close ``` if needed, then strip html
				return stripTrailingOpenHtml(fixUnclosedCodeBlock(text));
			}

			// 3. existing JSON/regex extraction kept, only tail-call changed
			function extractExampleText(rawData: string) {
				try {
					const parsed = JSON.parse(rawData);
					if (parsed && typeof parsed.example_text === "string") {
						return postProcess(parsed.example_text);
					}
				} catch (_) {
					/* ignore; streaming JSON may be incomplete */
				}

				const match = rawData.match(/"example_text"\s*:\s*"(.*)/s);
				if (!match) return "";

				let partial = match[1];

				const quoteIdx = findUnescapedQuote(partial);
				if (quoteIdx !== -1) partial = partial.slice(0, quoteIdx);

				try {
					return postProcess(JSON.parse(`"${partial}"`));
				} catch (_) {
					return postProcess(partial);
				}
			}

			function findUnescapedQuote(str: string) {
				for (let i = 0; i < str.length; i++) {
					if (str[i] === '"') {
						let slashes = 0;
						for (let j = i - 1; j >= 0 && str[j] === "\\"; j--) slashes++;
						if (slashes % 2 === 0) return i;
					}
				}
				return -1;
			}

			/* -------------------------------------------------
			 * state update
			 * ------------------------------------------------- */
			const item = materialItems.value.find(
				i => i.type === "example" && i.call_id === call_id,
			);

			if (item) {
				(item as any).raw_data += delta; // always accumulate the full stream
				(item as any).text = extractExampleText((item as any).raw_data); // safe text for display
			}
		},
		done: async () => {
			triggerTexRender();
		},
	},
	// whiteboard
	show_whiteboard: {
		done: async () => {
			currentTab.value = "whiteboard";
		},
	},
	get_whiteboard_content: {
		done: async () => {
			watchingWhiteboardDescription.value = true;
			while (whiteboardDescriptionIsDirty.value || loadingWhiteboardDescription.value) {
				await new Promise(resolve => setTimeout(resolve, 250));
			}
			watchingWhiteboardDescription.value = false;
			return currentWhiteboardDescription.value || "Nessun contenuto nella lavagna.";
		},
	},
	write_whiteboard_content: {
		done: async ({ type, px, py, content, length, direction, area, text }) => {
			if (!whiteboardApi.value) {
				console.error("Whiteboard API not initialized");
				return;
			}
			tutorIsUpdatingWhiteboard.value = true;
			if (type === "text") {
				await drawText(whiteboardApi.value.api, content, px, py);
			}
			setTimeout(() => {
				tutorIsUpdatingWhiteboard.value = false;
			}, 1100);
		},
	},
	draw_diagram_or_table_on_whiteboard: {
		done: async ({ diagram_code, px, py }) => {
			if (!whiteboardApi.value) {
				console.error("Whiteboard API not initialized");
				return;
			}
			tutorIsUpdatingWhiteboard.value = true;

			let elements: ExcalidrawElementSkeleton[] = [],
				files: any = {};
			try {
				const parsed = await parseMermaidToExcalidraw(diagram_code, {
					// fontSize: 12 //DEFAULT_FONT_SIZE,
				});
				elements = parsed.elements;
				files = parsed.files;
			} catch (e) {
				// Error handling
				console.error("Error parsing mermaid diagram:", e);

				// create a text element with the original code
				elements = [
					{
						type: "text",
						id: uuidv4(),
						x: px || 0,
						y: py || 0,
						text: diagram_code,
					},
				];
			}

			// TODO handle px py
			const excalidrawElements = convertToExcalidrawElements(elements);

			const diagramId = `diagram_${Object.keys(whiteboardDiagrams.value).length + 1}`;
			whiteboardDiagrams.value[diagramId] = excalidrawElements.map(el => el.id);

			whiteboardApi.value.api.addFiles(Object.values(files ?? {}));

			whiteboardApi.value.api.updateScene({
				elements: [...whiteboardApi.value.api.getSceneElements(), ...excalidrawElements],
			});

			setTimeout(() => {
				tutorIsUpdatingWhiteboard.value = false;
			}, 1100);

			return {
				diagram_id: diagramId,
			};
		},
	},
	edit_diagram_or_table_on_whiteboard: {
		done: async ({ diagram_id, new_diagram_code }) => {
			let elements: ExcalidrawElementSkeleton[] = [],
				files: any = {};
			try {
				const parsed = await parseMermaidToExcalidraw(new_diagram_code, {
					// fontSize: 12 //DEFAULT_FONT_SIZE,
				});
				elements = parsed.elements;
				files = parsed.files;
			} catch (e) {
				// Error handling
				console.error("Error parsing mermaid diagram:", e);

				// create a text element with the original code
				elements = [
					{
						type: "text",
						id: uuidv4(),
						x: 0,
						y: 0,
						text: new_diagram_code,
					},
				];
			}

			const excalidrawElements = convertToExcalidrawElements(elements);

			// delete the existing elements for the diagram
			if (!whiteboardDiagrams.value[diagram_id]) {
				console.error(`Diagram with id ${diagram_id} not found`);
				return {
					error: `Diagram with id ${diagram_id} not found, available diagrams: ${Object.keys(
						whiteboardDiagrams.value,
					).join(", ")}`,
				};
			}
			const existingElements = whiteboardApi.value.api.getSceneElements();
			const elementsToDelete = existingElements.filter(el =>
				whiteboardDiagrams.value[diagram_id].includes(el.id),
			);
			whiteboardApi.value.api.updateScene({
				elements: existingElements.filter(el => !elementsToDelete.includes(el)),
			});

			whiteboardDiagrams.value[diagram_id] = excalidrawElements.map(el => el.id);

			// TODO handle px py

			whiteboardApi.value.api.addFiles(Object.values(files ?? {}));

			whiteboardApi.value.api.updateScene({
				elements: [...whiteboardApi.value.api.getSceneElements(), ...excalidrawElements],
			});

			return {
				diagram_id: diagram_id,
			};
		},
	},
	// code editor
	show_code_editor: {
		done: async () => {
			currentTab.value = "code";
		},
	},
	get_code_editor_content: {
		done: async () => ({ code: codeEditorValue.value }),
	},
	run_editor_code: {
		done: async () => {
			return await runCode();
		},
	},
	insert_code: {
		done: async ({ code, position, line, anchor_code }) => {
			while (editorLock.value) {
				await new Promise(resolve => setTimeout(resolve, 100));
			}
			editorLock.value = true; // prevent concurrent edits
			disableCodeEditorUpdateMessage.value = true; // disable the update message

			const model = monacoApi.value?.getModel();
			if (!model) {
				console.error("Monaco model not found");
				return;
			}

			const insertOffset =
				findNearestOccurrence(codeEditorValue.value, anchor_code, line, position) +
				anchor_code.length;

			const insertPos = model.getPositionAt(insertOffset);

			if (!insertPos) {
				console.error("Could not resolve insert position", {
					position,
					line,
					anchor_code,
				});
				return;
			}

			// Prepare the range for insertion
			let currentRange = new monaco.Range(
				insertPos.lineNumber,
				insertPos.column,
				insertPos.lineNumber,
				insertPos.column,
			);

			console.log(
				">> insert_code",
				code,
				"after:",
				codeEditorValue.value.slice(insertOffset - anchor_code.length, insertOffset),
				currentRange,
			);

			// highlight the line where the insertion occurs
			const [decId] = monacoApi.value?.deltaDecorations(
				[],
				[
					{
						range: currentRange,
						options: {
							className: "highlighted-code highlight-short",
							isWholeLine: true,
						},
					},
				],
			) as any;

			// Type one character at a time
			for (const char of code) {
				await new Promise(resolve =>
					setTimeout(resolve, 3 + Math.floor(Math.random() * 20)),
				);

				// Insert one character at the current position
				monacoApi.value?.executeEdits(null, [
					{
						range: currentRange,
						text: char,
						forceMoveMarkers: true,
					},
				]);

				// if the char is newline, increase the line number and reset column
				if (char === "\n") {
					currentRange = new monaco.Range(
						currentRange.startLineNumber + 1,
						1,
						currentRange.endLineNumber + 1,
						1,
					);
					continue;
				}

				// Move the range one column to the right for next char
				currentRange = new monaco.Range(
					currentRange.startLineNumber,
					currentRange.startColumn + 1,
					currentRange.endLineNumber,
					currentRange.endColumn + 1,
				);
			}

			editorLock.value = false; // release the lock
			disableCodeEditorUpdateMessage.value = false; // re-enable the update message
			setTimeout(() => monacoApi.value?.deltaDecorations([decId], []), 3000); // remove highlight after typing
		},
	},
	replace_code: {
		done: async ({
			new_code,
			start_position,
			end_position,
			start_line,
			end_line,
			anchor_code,
		}) => {
			while (editorLock.value) {
				await new Promise(resolve => setTimeout(resolve, 100));
			}
			editorLock.value = true; // prevent concurrent edits
			disableCodeEditorUpdateMessage.value = true; // disable the update message

			const model = monacoApi.value?.getModel();
			if (!model) {
				console.error("Monaco model not found");
				return;
			}

			const fullText = codeEditorValue.value;
			// Find the exact offsets of the anchor region
			const startOffset = findNearestOccurrence(
				fullText,
				anchor_code,
				start_line,
				start_position,
			);
			const endOffset = startOffset + anchor_code.length;

			const startPos = model.getPositionAt(startOffset);
			const endPos = model.getPositionAt(endOffset);

			// Initial range covering the text to be replaced
			const deleteRange = new monaco.Range(
				startPos.lineNumber,
				startPos.column,
				endPos.lineNumber,
				endPos.column,
			);

			console.log(
				">> replace_code:",
				fullText.slice(startOffset, endOffset),
				"→",
				new_code,
				deleteRange,
			);

			// highlight the line where the replacement occurs
			const [decId] = monacoApi.value?.deltaDecorations(
				[],
				[
					{
						range: deleteRange,
						options: {
							className: "highlighted-code highlight-short",
							isWholeLine: true,
						},
					},
				],
			) as any;

			// 1) Delete the old text in one go
			monacoApi.value?.executeEdits(null, [
				{
					range: deleteRange,
					text: "",
					forceMoveMarkers: true,
				},
			]);

			// 2) Collapse to the insertion point (startPos)
			let insertRange = new monaco.Range(
				startPos.lineNumber,
				startPos.column,
				startPos.lineNumber,
				startPos.column,
			);

			// 3) “Type” new_code one character at a time
			for (const char of new_code) {
				const delay = 3 + Math.floor(Math.random() * 20);
				await new Promise(resolve => setTimeout(resolve, delay));

				monacoApi.value?.executeEdits(null, [
					{
						range: insertRange,
						text: char,
						forceMoveMarkers: true,
					},
				]);

				// advance the range by one column
				insertRange = new monaco.Range(
					insertRange.startLineNumber,
					insertRange.startColumn + 1,
					insertRange.endLineNumber,
					insertRange.endColumn + 1,
				);
			}
			editorLock.value = false; // release the lock
			disableCodeEditorUpdateMessage.value = false; // re-enable the update message
			setTimeout(() => monacoApi.value?.deltaDecorations([decId], []), 3000); // remove highlight after typing
		},
	},
	highlight_code: {
		done: async ({ anchor_code, start_position, end_position, start_line, end_line }) => {
			const model = monacoApi.value?.getModel();
			if (!model) {
				console.error("Monaco model not found");
				return;
			}
			const fullText = codeEditorValue.value; //!model.getValue();

			const startOffset = findNearestOccurrence(
				fullText,
				anchor_code,
				start_line,
				start_position,
			);
			if (startOffset === null) {
				console.error("Cannot resolve highlight startOffset", {
					fullText,
					start_position,
					start_line,
					anchor_code,
				});
				return;
			}

			const endOffset = startOffset + anchor_code.length;

			const startPos = model.getPositionAt(startOffset);
			const endPos = model.getPositionAt(endOffset);

			const range = new monaco.Range(
				startPos.lineNumber,
				startPos.column,
				endPos.lineNumber,
				endPos.column,
			);

			console.log("highlighting", fullText.slice(startOffset, endOffset), range);

			const [decId] = monacoApi.value?.deltaDecorations(
				[],
				[
					{
						range,
						options: {
							className: "highlighted-code highlight-long",
							isWholeLine: false,
						},
					},
				],
			)!;

			setTimeout(() => {
				monacoApi.value?.deltaDecorations([decId], []);
			}, 8000);
		},
	},
};

const endSession = async () => {
	if (sessionState.value !== "active") {
		return;
	}

	// avoid closing the session while the assistant is still talking
	await new Promise(resolve => setTimeout(resolve, 1500));
	while (assistantTalking.value) {
		await new Promise(resolve => setTimeout(resolve, 100));
	}

	// await axios.post(`courses/${courseId.value}/realtime_session_end/`);
	sessionState.value = "ended";

	pc.value?.close();
	pc.value = null;

	dataChannel.value?.close();
	dataChannel.value = null;

	if (audioStream.value) {
		audioStream.value.getTracks().forEach(track => track.stop());
	}
	audioStream.value = null;

	isListening.value = false;
};

const handleFunctionCall = async ({ functionName, functionArgs, callId }) => {
	try {
		let response: any = null;

		// if the tool is a local fn, handle it directly
		pendingFunctions.value[functionName] = true;
		if (localFns[functionName]) {
			response = (await localFns[functionName].done?.(functionArgs)) ?? { status: "ok" };
		} else {
			// otherwise, call the function via the API
			response = (
				await axios.post(`integrations/tutor/perform_tool_call/`, {
					session_id: sessionId.value,
					tool_name: functionName,
					tool_args: functionArgs,
				})
			).data;
			if (functionName === "get_exercises_by_keywords") {
				// TODO make it more elegant and generic
				fetchedExercises.value = response.output;
				console.log("Fetched exercises:", fetchedExercises.value);
				// ! hacky
				// remove base64 images and html from the text of exercises, and truncate to 1000 chars
				response = {
					...response,
					output: response.output.map(exercise => ({
						...exercise,
						sub_exercises: undefined,
						text: exercise.text
							.replace(/<img[^>]*>/g, "[image]")
							.replace(/<[^>]+>/g, "")
							.slice(0, 1000),
					})),
				};
			}
		}
		setTimeout(() => (pendingFunctions.value[functionName] = false), 1200);
		sendClientEvent({
			type: "conversation.item.create",
			item: {
				type: "function_call_output",
				call_id: callId,
				output: JSON.stringify(response),
			},
		});
		sessionData.value.logs.push({
			role: "assistant",
			timestamp: new Date().toISOString(),
			content: {
				type: "function_call_output",
				call_id: callId,
				name: functionName,
				output: response,
			},
		});
		console.log("Function call response:", response);
		sendClientEvent({ type: "response.create" });
	} catch (error) {
		setErrorNotification(_("misc.error_occurred"), true);
		console.error("Error handling function call:", error);
		sessionData.value.errors.push(
			`[${callId}] Error handling function call ${functionName}: ${error}`,
		);
	}
};

/** --- state --- */

async function init() {
	showStartDialog.value = false;
	await getMicPermission();

	sessionState.value = "starting";
	// Get an ephemeral key from your server - see server code below
	let tokenResponse: any = null;
	try {
		tokenResponse = await axios.post(
			`integrations/tutor/start_session/?course_id=${courseId.value}`,
		);
	} catch (error) {
		// check if rate limit is reached
		if ((error as any).response.status === 429) {
			setErrorNotification(_("misc.rate_limit_usage_reached"), true);
			sessionState.value = "init";
			return;
		}
	}
	const data = tokenResponse.data;
	const EPHEMERAL_KEY = data.client_secret.value;

	sessionId.value = data.session_id;

	// Create a peer connection
	pc.value = new RTCPeerConnection();

	// Set up to play remote audio from the model
	const audioEl = document.createElement("audio");
	audioEl.autoplay = true;
	pc.value.ontrack = e => (audioEl.srcObject = e.streams[0]);

	await startRecording();

	// Set up data channel for sending and receiving events
	dataChannel.value = pc.value.createDataChannel("oai-events");
	dataChannel.value.addEventListener("message", (e: MessageEvent) => {
		// Realtime server events appear here!
		const data = JSON.parse(e.data);
		const type = data.type;

		// console.log("Received event:", type, data);

		switch (type) {
			case "response.done":
				console.log("Response done:", data);
				sessionData.value.debug.push({
					type: "response.done",
					timestamp: new Date().toISOString(),
					usage: data.response.usage,
				});
				break;
			// sessionData.value.logs.push({
			// 	role: "assistant",
			// 	timestamp: new Date().toISOString(),
			// 	content: data,
			// });
			// break;
			// function calls
			case "response.output_item.added":
				if (data.item.type === "function_call" && localFns[data.item.name]) {
					callIdToFunctionName.value[data.item.call_id] = data.item.name;
					localFns[data.item.name].start?.({
						call_id: data.item.call_id,
					});
				}
				break;
			case "response.function_call_arguments.delta":
				const streamingFnName = callIdToFunctionName.value[data.call_id];
				if (localFns[streamingFnName]) {
					localFns[streamingFnName].delta?.({
						delta: data.delta,
						call_id: data.call_id,
					});
				}
				break;
			case "response.function_call_arguments.done":
				console.log("Function call arguments:", data.name, data.arguments);
				const fnName = data.name;
				const callId = data.call_id;
				let functionArgs = null;
				try {
					functionArgs = JSON.parse(data.arguments);
				} catch (e) {
					console.error("Error parsing function arguments:", e);
				}
				sessionData.value.logs.push({
					role: "assistant",
					timestamp: new Date().toISOString(),
					content: {
						type: "function_call",
						call_id: callId,
						name: fnName,
						arguments: functionArgs,
					},
				});
				handleFunctionCall({ functionName: fnName, functionArgs, callId });
				break;
			// audio transcript
			case "response.audio_transcript.delta":
				pushOrUpdateTranscriptItem("assistant", data.item_id, data.delta);
				break;
			case "response.audio_transcript.done":
				sessionData.value.logs.push({
					role: "assistant",
					timestamp: new Date().toISOString(),
					content: data.transcript,
				});
				break;
			case "conversation.item.input_audio_transcription.delta":
				pushOrUpdateTranscriptItem("user", data.item_id, data.delta);
				break;
			case "conversation.item.input_audio_transcription.completed":
				sessionData.value.logs.push({
					role: "user",
					timestamp: new Date().toISOString(),
					content: data.transcript,
				});
				break;
			// speech
			case "input_audio_buffer.speech_started":
				userTalking.value = true;
				assistantTalking.value = false;
				setTimeout(() => {
					if (showStartInstructions.value) {
						showStartInstructions.value = false;
						runCountDown.value = true;
					}
				}, 500);
				break;
			case "input_audio_buffer.speech_stopped":
				userTalking.value = false;
				break;
			case "output_audio_buffer.started":
				assistantTalking.value = true;
				break;
			case "output_audio_buffer.stopped":
				assistantTalking.value = false;
				break;
			default:
				console.log("!", type, data);
		}
	});

	// Start the session using the Session Description Protocol (SDP)
	const offer = await pc.value.createOffer();
	await pc.value.setLocalDescription(offer);

	const model = "gpt-4o-realtime-preview-2025-06-03";
	const sdpResponse = await axios.post(
		`${openApiRealtimeBaseUrl}?model=${model}`,
		offer.sdp,
		{
			headers: {
				Authorization: `Bearer ${EPHEMERAL_KEY}`,
				"Content-Type": "application/sdp",
			},
		},
	);

	const answer = {
		type: "answer",
		sdp: sdpResponse.data,
	};

	await pc.value.setRemoteDescription(answer as any);

	sessionState.value = "active";

	setTimeout(() => {
		showStartInstructions.value = true;
	}, 500);
}

onMounted(async () => {
	const store = useMainStore();
	// if (!store.getCourseById(courseId.value)?.features?.realtime_tutor) {
	// 	// redirect to course page
	// 	window.location.href = `/courses/${courseId.value}/`;
	// 	return;
	// }

	window.addEventListener("beforeunload", beforeWindowUnload);
	const {
		data: { rate_limit, session_time_limit },
	} = await axios.get(`integrations/tutor/info/`);
	rateLimit.value = rate_limit;
	timeLimitSeconds.value = session_time_limit ?? 5 * 60;
});

const onTimeUp = async () => {
	// don't interrupt the assistant if it's still talking
	while (assistantTalking.value) {
		await new Promise(resolve => setTimeout(resolve, 500));
	}
	// stop the user from talking
	await new Promise(resolve => setTimeout(resolve, 500));
	userTalking.value = false;
	stopRecording();

	sendTextMessage(
		`[Messaggio di sistema inviato automaticamente. Il tempo a disposizione per questa sessione è terminato. Informa lo studente che la sessione è terminata.]`,
		{
			role: "system",
			forceRespond: true,
		},
	);
	endSession();
};

const pauseSession = () => {};

/** --- data --- */

const materialItemCursor = ref(0);
const getMaterialById = (id: string) => {
	return materialItems.value.find(item => item.id === id);
};
const setMaterialItemCursor = (id: string) => {
	const index = materialItems.value.findIndex(item => item.id === id);
	if (index !== -1) {
		materialItemCursor.value = index;
	} else {
		console.warn("Material item not found:", id);
	}
};
const materialItems = ref<
	({ id: string } & (
		| {
				type: "material";
				url: string;
				page: number;
		  }
		| {
				type: "example";
				text: string;
				call_id: string;
				raw_data: string;
		  }
		| {
				type: "exercise";
				text: string;
				solution?: string;
				choices?: {
					id: string;
					text: string;
					correctness: number;
				}[];
				testcases?: ({ id: string } & (
					| {
							code: string;
					  }
					| { stdin: string; expected_stdout: string }
				))[];
				execution_results?: object;
				submitted?: boolean;
		  }
	))[]
>([]);

const currentMaterial = computed(() => {
	if (materialItems.value.length === 0) {
		return null;
	}
	return materialItems.value[materialItemCursor.value];
});

const onGoToLesson = () => {
	// the url in currentMaterial is in the form `/courses/5/nodes/41/download/`,
	// we extract the ids and build it in the form `/courses/5/material/41/`
	const currentItem = currentMaterial.value;
	if (!currentItem || currentItem.type !== "material") {
		return;
	}
	const parsedUrl = new URL(currentItem.url);
	const urlParts = parsedUrl.pathname.split("/");
	const courseId = urlParts[2];
	const materialId = urlParts[4];
	const newUrl = `/courses/${courseId}/material/${materialId}/`;
	// open in new tab
	window.open(newUrl, "_blank");
};

const fetchedExercises = ref<any[]>([]);

// ---- code editor -----------------------------------------------

const codeEditorValue = ref<string>("");
const disableCodeEditorUpdateMessage = ref(false);
const sendUpdatedCodeEditorValue = debounce(() => {
	sendTextMessage(
		`[Messaggio di sistema inviato automaticamente. Lo studente ha scritto del codice nell'editor. Rispondi solo se vuoi fornirgli un feedback o aiuto, altrimenti se non lo ritieni necessario, non rispondere. Se lo studente sembra aver scritto codice incompleto e probabilmente sta ancora scrivendo, non dire nulla.]
Codice scritto dallo studente nell'editor:
\`\`\`
${codeEditorValue.value}
\`\`\``,
		{
			role: "system",
			forceRespond: false,
		},
	);
}, 1000);

const playgroundExecutionResults = ref<any[]>([]);

const formatPlaygroundExecutionResultsRow = (row: any) => {
	if (row.message.data) {
		try {
			const parsedData = JSON.parse(row.message.data);
			if (Array.isArray(parsedData)) {
				return parsedData.join("\t");
			}
		} catch (e) {
			console.error("Error parsing message data:", e);
			return row.message.data; // fallback to original data if parsing fails
		}
	}

	if (row.message.error) {
		return row.message.error;
	}

	return typeof row.message === "string"
		? row.message
		: typeof row.message === "object"
		? JSON.stringify(row.message, null, 2)
		: row.message;
};

// used to prevent concurrent changes by the assistant
const editorLock = ref(false);
const monacoApi = shallowRef<monaco.editor.IStandaloneCodeEditor | null>(null);
const onMonacoApiReady = (api: monaco.editor.IStandaloneCodeEditor) => {
	monacoApi.value = api;
	console.log("Monaco API ready:", monacoApi, monacoApi.value, api);
};
const runningCode = ref(false);
const runCoolDown = ref(0);
const RUN_COOLDOWN = 5;
const runCode = async () => {
	const item = materialItems.value[materialItemCursor.value];

	try {
		runningCode.value = true;
		playgroundExecutionResults.value = [];

		// playground mode - no exercise, just run the code
		if (!item || item.type !== "exercise" || (item as any).exercise.type !== "code") {
			return new Promise(resolve => {
				const eventSource = new EventSource(
					`${
						axios.defaults.baseURL
					}/integrations/tutor/run_code/?code=${encodeURIComponent(
						codeEditorValue.value,
					)}&session_id=${encodeURIComponent(sessionId.value!)}`,
					{
						headers: {
							Authorization: `Bearer ${metaStore.token}`,
						},
					},
				);
				eventSource.onmessage = async event => {
					if (event.data === "[DONE]") {
						eventSource.close();
						resolve(playgroundExecutionResults.value);
						return;
					}
					const data = JSON.parse(event.data);
					console.log("data", data);
					if (data.message?.type || data.message?.error) {
						playgroundExecutionResults.value.push(data as any);
					} else {
						console.log("Full program execution:", data);
					}
				};
			});
		} else {
			// exercise mode - run the code with testcases and get execution results
			const { execution_results: executionResults } = (
				await axios.post(`integrations/tutor/run_code/`, {
					exercise_id: (item as any).exercise.id,
					session_id: sessionId.value,
					code: codeEditorValue.value,
				})
			).data;
			item.execution_results = executionResults;
			return executionResults;
		}
	} catch (error) {
		console.error("Error running code:", error);
		return {
			status: "error",
			message:
				(error as any).message || "Errore sconosciuto durante l'esecuzione del codice.",
		};
	} finally {
		runningCode.value = false;
		runCoolDown.value = RUN_COOLDOWN;
		const coolDownHandle = setInterval(() => {
			runCoolDown.value--;
			if (runCoolDown.value <= 0) {
				clearInterval(coolDownHandle);
			}
		}, 1000);
	}
};

/**
 * Find the most plausible occurrence of `query` in `source`.
 *
 * @param {string} source      &ndash; the whole multi-line string (e.g. file contents)
 * @param {string} query       &ndash; the fragment of code we are looking for
 * @param {number} hintLine    &ndash; 1-based line number (more trustworthy)
 * @param {number} hintPos     &ndash; 1-based char index in the file (rough estimate)
 * @returns {number}             1-based start index of the chosen occurrence, or -1
 */
function findNearestOccurrence(
	source: string,
	query: string,
	hintLine: number,
	hintPos: number,
) {
	if (!query || !source) return -1;

	// ------------------------------------------------------------------
	// 1. Build an array with the 0-based start offset of each line.
	// ------------------------------------------------------------------
	const lineStarts = [0]; // line 1 always starts at offset 0
	for (let i = 0; i < source.length; ++i) {
		if (source[i] === "\n") lineStarts.push(i + 1);
	}
	const totalLines = lineStarts.length;

	// Helper: map a character offset → 1-based line number (binary search).
	function lineOf(offset: number) {
		let lo = 0,
			hi = totalLines - 1;
		while (lo <= hi) {
			const mid = (lo + hi) >> 1;
			if (lineStarts[mid] <= offset) {
				if (mid === totalLines - 1 || lineStarts[mid + 1] > offset) return mid + 1; // +1 → 1-based
				lo = mid + 1;
			} else {
				hi = mid - 1;
			}
		}
		return totalLines; // shouldn’t happen
	}

	// ------------------------------------------------------------------
	// 2. Collect every occurrence of `query`.
	// ------------------------------------------------------------------
	const hits: any[] = [];
	let idx = source.indexOf(query);
	while (idx !== -1) {
		hits.push(idx); // 0-based
		idx = source.indexOf(query, idx + 1);
	}
	if (hits.length === 0) return -1; // not found anywhere

	// ------------------------------------------------------------------
	// 3. Score every hit.
	// ------------------------------------------------------------------
	const LINE_WEIGHT = 1000000; // tune to taste
	let bestIdx = hits[0];
	let bestScore = Number.POSITIVE_INFINITY;

	for (const hit of hits) {
		const lineDiff = Math.abs(lineOf(hit) - hintLine);
		const charDiff = Math.abs(hit + 1 - hintPos); // +1 → caller’s 1-based world
		const score = lineDiff * LINE_WEIGHT + charDiff;

		if (score < bestScore) {
			bestScore = score;
			bestIdx = hit;
		}
	}

	// ------------------------------------------------------------------
	// 4. Return 1-based character index, or -1.
	// ------------------------------------------------------------------
	return bestIdx;
}

watch(codeEditorValue, () => {
	if (sessionState.value === "active" && !disableCodeEditorUpdateMessage.value) {
		sendUpdatedCodeEditorValue();
	}
});

// -----------------------------------------------------------------

// ---- whiteboard -------------------------------------------------
const whiteboardContent = ref<any>({ elements: [], files: {} });

const whiteboardApi = ref<any>(null);
const onWhiteboardApiReady = (api: any) => {
	whiteboardApi.value = api;
	console.log("Whiteboard API ready:", whiteboardApi.value);
};

const currentWhiteboardDescription = ref<string | null>(null);
const tutorIsUpdatingWhiteboard = ref(false);
const watchingWhiteboardDescription = ref(false);
const whiteboardDescriptionIsDirty = ref(false);
const loadingWhiteboardDescription = ref(false);
const whiteboardDescriptionPreviousResponseId = ref<string | null>(null);

const whiteboardGrid = ref<Record<string, CellCoordinates>>({});

function drawGridWithMappingFromElements(
	canvas: HTMLCanvasElement,
	elements: any[], // readonly ExcalidrawElement[],
	cellSize: number,
): Record<string, CellCoordinates> {
	const ctx = canvas.getContext("2d")!;
	if (!ctx) throw new Error("Canvas context is null");

	// 1. Bounding box reale degli elementi
	let minX = Infinity;
	let minY = Infinity;
	let maxX = -Infinity;
	let maxY = -Infinity;

	for (const el of elements) {
		minX = Math.min(minX, el.x);
		minY = Math.min(minY, el.y);
		maxX = Math.max(maxX, el.x + el.width);
		maxY = Math.max(maxY, el.y + el.height);
	}

	const offsetX = Math.floor(minX / cellSize) * cellSize;
	const offsetY = Math.floor(minY / cellSize) * cellSize;

	const width = maxX - offsetX;
	const height = maxY - offsetY;

	const cols = Math.ceil(width / cellSize);
	const rows = Math.ceil(height / cellSize);

	const cellMap: Record<string, CellCoordinates> = {};

	// 2. Stile
	ctx.strokeStyle = "rgba(0, 0, 0, 0.1)";
	ctx.lineWidth = 1;
	ctx.font = "15px monospace";
	ctx.fillStyle = "rgba(0, 0, 255, 0.8)";
	ctx.textAlign = "left";
	ctx.textBaseline = "top";

	// 3. Disegno
	let cellIdNum = 0;
	for (let x = 0; x < cols; x++) {
		for (let y = 0; y < rows; y++) {
			const localX = x * cellSize;
			const localY = y * cellSize;

			// Ma le coordinate globali sono offset + local
			const absX = offsetX + x * cellSize;
			const absY = offsetY + y * cellSize;

			const cellId = cellIdNum.toString().padStart(3, "0");
			cellIdNum++;

			// Disegna nel canvas da (0,0)
			ctx.beginPath();
			ctx.rect(localX, localY, cellSize, cellSize);
			ctx.stroke();

			// write text with a white border
			// ctx.fillStyle = "white";
			// ctx.fillText(cellId, localX + 5, localY + 5);
			// ctx.fillStyle = "rgba(0, 0, 255, 0.8)";
			// ctx.fillStyle = "blue";
			// ctx.strokeStyle = "white";
			// // ctx.font = "20pt Verdana";
			// ctx.fillText(cellId, localX + 5, localY + 5);
			// ctx.strokeText(cellId, localX + 5, localY + 5);

			// make the text center aligned in the cell
			// use this python code in js
			// text_x = (top_left_x + bottom_right_x) / 2 - text_offset_x
			// text_y = (top_left_y + bottom_right_y) / 2

			const textX = localX + cellSize / 2 - ctx.measureText(cellId).width / 2;
			const textY = localY + cellSize / 2 - parseInt(ctx.font, 10) / 2;

			ctx.strokeStyle = "white";
			ctx.lineWidth = 2;
			ctx.strokeText(cellId, textX, textY);
			ctx.fillStyle = "rgba(0, 0, 255, 0.8)";
			ctx.fillText(cellId, textX, textY);

			// reset styles for the next cell
			ctx.strokeStyle = "rgba(0, 0, 0, 0.1)";
			ctx.lineWidth = 1;
			ctx.fillStyle = "rgba(0, 0, 255, 0.8)";

			// Mapping usa le coordinate reali della whiteboard
			cellMap[cellId] = {
				x: absX,
				y: absY,
				width: cellSize,
				height: cellSize,
			};
		}
	}

	return cellMap;
}

function replaceCellListsWithBoundingBoxes(description: string): string {
	return description.replace(/\[([0-9]{3}(?:,\s*[0-9]{3})*)\]/g, (match, cellListStr) => {
		const cellIds = cellListStr.split(",").map(id => id.trim());
		console.log("Replacing cell list:", cellIds, "in grid:", whiteboardGrid.value);
		const coords = cellIds
			.map(id => whiteboardGrid.value[id])
			.filter((c): c is CellCoordinates => !!c); // rimuove undefined

		if (coords.length === 0) return match; // fallback: non sostituire se non trovate

		const minX = Math.min(...coords.map(c => c.x));
		const minY = Math.min(...coords.map(c => c.y));
		const maxX = Math.max(...coords.map(c => c.x + c.width));
		const maxY = Math.max(...coords.map(c => c.y + c.height));

		return `[bbox: (${minX}, ${minY}), (${maxX}, ${maxY})]`;
	});
}

const whiteboardHandler = debounce(async (content: any) => {
	console.log("Whiteboard content changed:", content);
	// compute diff to get only the new elements
	const currentElements = whiteboardContent.value.elements;
	// const newElements = content.elements.filter(
	// 	(el: any) => !currentElements.some((e: any) => e.id === el.id),
	// );
	const newElements = content.elements;
	// TODO handle deleted elements
	if (newElements.length === 0) {
		// no new elements, nothing to do
		return;
	}

	loadingWhiteboardDescription.value = true;

	const canvas = await whiteboardApi.value.exportToCanvas({
		elements: newElements, //whiteboardApi.value.api.getSceneElements(),
		files: {}, //whiteboardApi.getFiles(),
		//   getDimensions: (width, height) => ({
		//     width,
		//     height,
		//     scale: 1,
		//   }),
	});

	whiteboardGrid.value = drawGridWithMappingFromElements(canvas, newElements, 50);
	console.log("Grid mapping:", whiteboardGrid.value);
	const blob = await new Promise<Blob>(resolve => {
		canvas.toBlob(resolve, "image/png");
	});

	// const blob = await whiteboardApi.value.exportToBlob({
	// 	elements: newElements,
	// 	files: content.files,
	// 	mimeType: "image/png",
	// });
	console.log("BLOB", blob);
	const imageAsBase64 = await new Promise<string>(resolve => {
		const reader = new FileReader();
		reader.onload = () => {
			resolve(reader.result as string);
		};
		reader.readAsDataURL(blob);
	});

	// save the new elements to the content
	whiteboardContent.value = content;

	// get the description of the new elements
	const {
		data: { output_text, response_id },
	} = await axios.post(`integrations/tutor/get_whiteboard_content_description/`, {
		session_id: sessionId.value,
		image_base64: imageAsBase64,
		// ! previous_response_id: whiteboardDescriptionPreviousResponseId.value,
	});

	whiteboardDescriptionPreviousResponseId.value = response_id;
	currentWhiteboardDescription.value = replaceCellListsWithBoundingBoxes(output_text);

	console.log(
		"Whiteboard description:",
		output_text,
		replaceCellListsWithBoundingBoxes(output_text),
	);

	whiteboardDescriptionIsDirty.value = false;
	loadingWhiteboardDescription.value = false;
}, 2500);
const onWhiteboardContentChange = async content => {
	if (tutorIsUpdatingWhiteboard.value) {
		return;
	}
	if (!whiteboardDescriptionIsDirty.value) {
		sendTextMessage(
			"[Messaggio di sistema inviato automaticamente. Lo studente ha modificato il contenuto della lavagna. Se ti serve avere il contenuto aggiornato della lavagna, chiama la funzione `get_whiteboard_content_description`.]",
			{
				role: "system",
				forceRespond: false,
			},
		);
	}
	whiteboardDescriptionIsDirty.value = true;
	await whiteboardHandler(content);
};

// ------------------------------------------------------

// ---- exercises ---------------------------------------

const currentMaterialAsExercise = computed(() => {
	if (!currentMaterial.value || currentMaterial.value.type !== "exercise") {
		return null;
	}

	return currentMaterial.value;
});

const currentExerciseCanBeSubmitted = computed(() => {
	// non-cloze
	if (currentMaterialAsExercise.value?.exercise.type !== "cloze") {
		return currentMaterialAsExercise.value?.submission?.selected_choices?.length !== 0;
	}
	// cloze
	return (currentMaterialAsExercise.value?.slot?.sub_slots || []).some(
		(s: any) => s.selected_choices?.length > 0,
	);
});

const updateExerciseSubmission = (
	payload: [keyof EventParticipationSlotSubmission, any],
) => {
	const item = materialItems.value[materialItemCursor.value];
	if (!item || item.type !== "exercise") {
		console.warn("No current exercise to update submission for");
		return;
	}
	if (!(payload[0] in (item as any).submission)) {
		console.warn("Invalid key in updateSubmission event", payload[0]);
		return;
	}
	(item as any).submission[payload[0]] = payload[1];
};

const updateClozeExerciseSubmission = event => {
	const slotId = event.slot.id;
	const change = event.payload;
	const item = materialItems.value[materialItemCursor.value];
	if (!item || item.type !== "exercise") {
		console.warn("No current exercise to update submission for");
		return;
	}
	if ((item as any).exercise.type !== "cloze") {
		console.warn("Current exercise is not a cloze exercise");
		return;
	}
	const itemSlot = (item as any).slot;
	const slot =
		slotId == itemSlot.id
			? itemSlot
			: itemSlot.sub_slots.find((s: any) => s.id == slotId);
	if (!slot) {
		console.warn("Slot not found in cloze exercise:", slotId);
		return;
	}
	slot[change[0]] = change[1];
};

const submitExerciseCurrentExerciseAnswer = async () => {
	const item = materialItems.value[materialItemCursor.value];
	if (!item || item.type !== "exercise") {
		console.warn("No current exercise to submit answer for");
		return;
	}

	const exerciseType = (item as any).exercise.type;

	try {
		if (exerciseType !== "cloze") {
			const selectedChoices = ((item as any).submission.selected_choices || []).map(
				(choiceId: any) =>
					(item as any).exercise.choices.find(
						(choice: { id: any }) => choice.id === choiceId,
					),
			);
			item.submitted = true;
			sendTextMessage(
				`Ho selezionato la risposta all'esercizio:
${JSON.stringify(
	exerciseType === "radio_choice" ? selectedChoices[0] : selectedChoices,
	null,
	2,
)}`,
				{ role: "user", forceRespond: true },
			);
		} else {
			// extract selected choices from sub-slots
			const selectedChoices = (item as any).slot.sub_slots.map(s =>
				s.exercise.choices.find((c: any) => c.id == s.selected_choices[0]),
			);
			item.submitted = true;
			sendTextMessage(
				`Ho completato l'esercizio con le seguenti risposte:
${JSON.stringify(selectedChoices, null, 2)}`,
				{ role: "user", forceRespond: true },
			);
		}
	} catch (error) {
		setErrorNotification(_("misc.error_occurred"), true);
		console.error("Error submitting exercise:", error);
	}
};

// ---- transcript and conversation steps -----------------------------

const pushOrUpdateTranscriptItem = (
	role: "user" | "assistant",
	itemId: string,
	text: string,
) => {
	// TODO push the transcripts under the conversation steps, and by clicking on a step, show the transcript items for that step
	const existingItem = transcriptItems.value.find(
		item => item.role === role && item.item_id === itemId,
	);
	if (existingItem) {
		existingItem.text += text;
	} else {
		transcriptItems.value.unshift({ role, item_id: itemId, text });
	}
};
const transcriptItems = ref<
	{
		role: "user" | "assistant";
		item_id: string;
		text: string;
	}[]
>([]);

const conversationSteps = ref<ConversationStep[]>([]);
const processedConversationSteps = computed(() =>
	conversationSteps.value.map(step => ({
		data: step,
	})),
);
const currentConversationStep = computed(() => {
	if (conversationSteps.value.length === 0) {
		return null;
	}
	return conversationSteps.value[0];
});

// -------------------------------------

// TODO handle uploading files, e.g. using the code interpreter

const sendTextMessage = (
	message: string,
	{
		role = "user",
		forceRespond = true,
		instructions = undefined,
	}: {
		role?: "user" | "system";
		forceRespond?: boolean;
		instructions?: string;
	},
) => {
	const event = {
		type: "conversation.item.create",
		item: {
			type: "message",
			role,
			content: [
				{
					type: "input_text",
					text: message,
				},
			],
		},
	};
	console.log("Sending text message:", message);
	sendClientEvent(event);
	if (forceRespond) {
		sendClientEvent({
			type: "response.create",
			...(instructions ? { response: { instructions } } : {}),
		});
	}
};

const triggerTexRender = () => {
	const metaStore = useMetaStore();
	metaStore.dirtyTex = true;
};

/**
 *

  ---- example for handling calls with additional instructions ---
  if (
          output.type === "function_call" &&
          output.name === "display_color_palette"
        ) {
          setFunctionCallOutput(output);
          setTimeout(() => {
            sendClientEvent({
              type: "response.create",
              response: {
                instructions: `
                ask for feedback about the color palette - don't repeat
                the colors, just ask if they like the colors.
              `,
              },
            });
          }, 500);

 */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (sessionState.value === 'init' || sessionState.value === 'starting')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("ul", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_14))
              ]),
              _hoisted_15
            ])
          ]),
          _hoisted_16,
          _createVNode(Btn, {
            class: "mx-auto mt-6 mb-2",
            loading: sessionState.value === 'starting',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showStartDialog.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("realtime.start")), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(Dialog, {
            onNo: _cache[1] || (_cache[1] = ($event: any) => (showStartDialog.value = false)),
            onYes: _cache[2] || (_cache[2] = ($event: any) => (init())),
            noText: _ctx.$t('dialog.default_cancel_text'),
            yesText: _ctx.$t('realtime.start'),
            showDialog: showStartDialog.value
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("realtime.start")), 1)
            ]),
            body: _withCtx(() => [
              (rateLimit.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                    _createTextVNode(_toDisplayString(_ctx.$t("misc.you_can_use_this_feature")) + " ", 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(rateLimitParsed)[0]) + " " + _toDisplayString(_ctx.$t("misc.times")), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`misc.per_${_unref(rateLimitParsed)[1]}`)) + ". ", 1)
                  ]))
                : _createCommentVNode("", true),
              (timeLimitSeconds.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_ctx.$t("realtime_sessions.time_limit_1")) + " ", 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(timeLimitSeconds.value / 60) + " " + _toDisplayString(_ctx.$t("misc.minutes")), 1),
                    _createTextVNode(". ")
                  ]))
                : _createCommentVNode("", true),
              _hoisted_21
            ]),
            _: 1
          }, 8, ["noText", "yesText", "showDialog"]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (rateLimit.value || timeLimitSeconds.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", null, [
                      (rateLimit.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                            _createTextVNode(_toDisplayString(_ctx.$t("misc.you_can_use_this_feature")) + " ", 1),
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(rateLimitParsed)[0]) + " " + _toDisplayString(_ctx.$t("misc.times")), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`misc.per_${_unref(rateLimitParsed)[1]}`)) + ". ", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (timeLimitSeconds.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                            _createTextVNode(_toDisplayString(_ctx.$t("realtime_sessions.time_limit_1")) + " ", 1),
                            _createElementVNode("span", _hoisted_27, _toDisplayString(timeLimitSeconds.value / 60) + " " + _toDisplayString(_ctx.$t("misc.minutes")), 1),
                            _createTextVNode(". ")
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createVNode(Avatar, {
                  class: _normalizeClass([
								'outline-4',
								userTalking.value ? 'outline-primary' : 'outline-transparent',
							]),
                  user: _unref(metaStore).user,
                  size: 'lg'
                }, null, 8, ["class", "user"]),
                false
                  ? (_openBlock(), _createBlock(MicTalking, {
                      key: 0,
                      talking: userTalking.value
                    }, null, 8, ["talking"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(WaveAnimation, {
                isSpeaking: assistantTalking.value || userTalking.value
              }, null, 8, ["isSpeaking"]),
              _createElementVNode("div", _hoisted_32, [
                (
								pendingFunctions.value['get_material'] ||
								pendingFunctions.value['get_exercises_by_keywords']
							)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_33, _hoisted_36))
                  : (pendingFunctions.value['get_whiteboard_content'])
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_37, _hoisted_42))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        style: {"width":"2.4rem","height":"2.4rem"},
                        class: _normalizeClass(["flex items-center p-2 overflow-hidden rounded-full bg-primary-light bg-opacity-20", [
								'outline-4',
								assistantTalking.value ? 'outline-primary' : 'outline-transparent',
							]])
                      }, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_43, _hoisted_46))
                      ], 2))
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(Timeline, { steps: _unref(processedConversationSteps) }, {
                default: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("p", null, _toDisplayString(data.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.material_ids, (materialItemId) => {
                      return (_openBlock(), _createElementBlock("div", { key: materialItemId }, [
                        _createVNode(Btn, {
                          outline: true,
                          variant: 'icon',
                          onClick: ($event: any) => (setMaterialItemCursor(materialItemId))
                        }, {
                          default: _withCtx(() => [
                            (getMaterialById(materialItemId)?.type === 'material')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_50, " book "))
                              : (getMaterialById(materialItemId)?.type === 'example')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_51, " lightbulb "))
                                : (getMaterialById(materialItemId)?.type === 'exercise')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, " description "))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.$t("tutor.unknown_material")), 1))
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["steps"])
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createVNode(Tabs, {
              class: "w-full",
              options: tabs.value,
              modelValue: currentTab.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentTab).value = $event))
            }, null, 8, ["options", "modelValue"]),
            _withDirectives(_createElementVNode("div", _hoisted_55, [
              (_unref(currentMaterial) && _unref(currentMaterial).type === 'material')
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createElementVNode("div", {
                      class: "chip border-0 flex items-center space-x-1 bg-light hover:bg-gray-100 transition-colors duration-200 ease-in-out cursor-pointer",
                      onClick: onGoToLesson
                    }, _hoisted_59)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_60, [
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_unref(currentMaterial) && _unref(currentMaterial).type === 'material')
                      ? (_openBlock(), _createBlock(IntegratedFileViewer, {
                          key: 0,
                          src: _unref(currentMaterial).url,
                          page: _unref(currentMaterial).page,
                          onPageChanged: _cache[4] || (_cache[4] = page => (materialItems.value[materialItemCursor.value].page = page))
                        }, null, 8, ["src", "page"]))
                      : (_unref(currentMaterial) && _unref(currentMaterial).type === 'example')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _createElementVNode("h3", _hoisted_62, _toDisplayString(_ctx.$t("tutor.example_header")), 1),
                            _createVNode(ProcessedTextFragment, {
                              class: "user-content",
                              value: _unref(currentMaterial).text
                            }, null, 8, ["value"])
                          ]))
                        : (_unref(currentMaterial) && _unref(currentMaterial).type === 'exercise')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                              _createElementVNode("h3", _hoisted_64, _toDisplayString(_ctx.$t("tutor.exercise_header")), 1),
                              (
										_unref(currentMaterialAsExercise) &&
										_unref(currentMaterialAsExercise).exercise.type !== 'code'
									)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                    (
											!reloadingExercise.value &&
											_unref(currentMaterialAsExercise).exercise.type !== 'cloze'
										)
                                      ? (_openBlock(), _createBlock(Exercise, {
                                          key: 0,
                                          exercise: _unref(currentMaterialAsExercise).exercise,
                                          submission: _unref(currentMaterialAsExercise).submission,
                                          onUpdateSubmission: updateExerciseSubmission,
                                          "read-only": _unref(currentMaterialAsExercise).submitted,
                                          "show-solution": _unref(currentMaterialAsExercise).submitted
                                        }, null, 8, ["exercise", "submission", "read-only", "show-solution"]))
                                      : (!reloadingExercise.value)
                                        ? (_openBlock(), _createBlock(ClozeExercise, {
                                            key: 1,
                                            class: "w-full",
                                            onUpdateSubmission: updateClozeExerciseSubmission,
                                            slot: _unref(currentMaterialAsExercise).slot,
                                            "show-scores": _unref(currentMaterialAsExercise).submitted,
                                            "read-only": _unref(currentMaterialAsExercise).submitted
                                          }, null, 8, ["slot", "show-scores", "read-only"]))
                                        : _createCommentVNode("", true),
                                    (!_unref(currentMaterialAsExercise)?.submitted)
                                      ? (_openBlock(), _createBlock(Btn, {
                                          key: 2,
                                          class: _normalizeClass(["mt-4 mr-auto", {
											'opacity-0': !_unref(currentExerciseCanBeSubmitted),
										}]),
                                          disabled: !_unref(currentExerciseCanBeSubmitted),
                                          onClick: submitExerciseCurrentExerciseAnswer
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("tutor.submit_exercise_answer")), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["class", "disabled"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createBlock(ProcessedTextFragment, {
                                    key: 1,
                                    class: "user-content",
                                    value: _unref(currentMaterialAsExercise)?.exercise?.text
                                  }, null, 8, ["value"]))
                            ]))
                          : (!pendingFunctions.value['get_material'])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                _hoisted_67,
                                _createElementVNode("h2", _hoisted_68, _toDisplayString(_ctx.$t("tutor.material_will_appear_here")), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                (_openBlock(), _createElementBlock("svg", _hoisted_70, _hoisted_73))
                              ]))
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, currentTab.value === 'material']
            ]),
            (currentTab.value === 'code')
              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                  _createVNode(CodeEditor, {
                    disabled: sessionState.value === 'ended',
                    "full-height": true,
                    modelValue: codeEditorValue.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((codeEditorValue).value = $event)),
                    language: 'typescript',
                    showRunButton: sessionState.value !== 'ended',
                    runCoolDown: runCoolDown.value,
                    running: runningCode.value || runCoolDown.value > 0,
                    onRun: _cache[6] || (_cache[6] = ($event: any) => (runCode())),
                    onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('blur'))),
                    onApiReady: onMonacoApiReady
                  }, {
                    runButton: _withCtx(() => [
                      _hoisted_75,
                      _createTextVNode(_toDisplayString(_ctx.$t("programming_exercise.run_code")) + " ", 1),
                      (runCoolDown.value > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_76, " (" + _toDisplayString(runCoolDown.value) + ")", 1))
                        : _createCommentVNode("", true),
                      (runCoolDown.value < 10)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_77, "0"))
                        : _createCommentVNode("", true)
                    ]),
                    sidePane: _withCtx(() => [
                      (
									_unref(currentMaterialAsExercise) &&
									_unref(currentMaterialAsExercise).exercise.type === 'code'
								)
                        ? (_openBlock(), _createBlock(ProcessedTextFragment, {
                            key: 0,
                            class: "user-content mb-4 mx-2",
                            value: _unref(currentMaterialAsExercise)?.exercise?.text
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      (
									_unref(currentMaterialAsExercise) && _unref(currentMaterialAsExercise).execution_results
								)
                        ? (_openBlock(), _createBlock(CodeExecutionResults, {
                            key: 1,
                            executionResults: _unref(currentMaterialAsExercise).execution_results,
                            testCases: _unref(currentMaterialAsExercise).exercise.testcases
                          }, null, 8, ["executionResults", "testCases"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_78, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(playgroundExecutionResults.value, (row, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([
											row.source === 'stdout' && row.message.type
												? row.message.type === 'error'
													? 'bg-danger-light bg-opacity-50'
													: row.message.type === 'warn'
													? 'bg-yellow-100'
													: 'bg-transparent'
												: 'bg-danger-light bg-opacity-50 ',
											'flex items-center md:space-x-6 space-x-4 px-2 py-1 rounded mb-0.5',
										])
                                }, [
                                  (row.message.type)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_79, [
                                        (row.message.type === 'error')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_80, " close "))
                                          : (row.message.type === 'warn')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_81, " warning "))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_82, " chevron_right "))
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", null, [
                                    _createElementVNode("pre", _hoisted_83, "\t\t\t\t\t\t\t\t\t\t\t\t" + _toDisplayString(formatPlaygroundExecutionResultsRow(row)) + "\n\t\t\t\t\t\t\t\t\t\t\t", 1)
                                  ])
                                ], 2)
                              ]))
                            }), 128))
                          ]))
                    ]),
                    bottom: _withCtx(() => [
                      _createVNode(_Transition, { name: "quick-bounce" }, {
                        default: _withCtx(() => [
                          (runningCode.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                _createVNode(Spinner, { fast: true }),
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t("programming_exercise.running_code")), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue", "showRunButton", "runCoolDown", "running"])
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_85, [
              _createVNode(DrawEditor, {
                disabled: sessionState.value === 'ended',
                style: {"height":"500px"},
                "initial-data": { elements: [], files: {} },
                onApiReady: onWhiteboardApiReady,
                onOnChange: onWhiteboardContentChange
              }, null, 8, ["disabled"])
            ], 512), [
              [_vShow, currentTab.value === 'whiteboard']
            ])
          ])
        ])),
    (sessionState.value !== 'init' && sessionState.value !== 'starting')
      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
          _createElementVNode("div", _hoisted_87, [
            _createVNode(Btn, {
              class: "rounded-full bg-primary bg-opacity-20 text-primary",
              outline: true,
              variant: 'transparent',
              disabled: sessionState.value === 'ended',
              onClick: _cache[8] || (_cache[8] = ($event: any) => (isListening.value ? stopRecording() : startRecording()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_88, _toDisplayString(isListening.value ? "mic" : "mic_off"), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createElementVNode("p", _hoisted_89, "Mic " + _toDisplayString(isListening.value ? "on" : "off"), 1)
          ]),
          _createElementVNode("div", _hoisted_90, [
            (_unref(endTimestamp))
              ? (_openBlock(), _createBlock(Countdown, {
                  key: 0,
                  onTimeUp: onTimeUp,
                  endTimestamp: _unref(endTimestamp),
                  isInitialized: runCountDown.value
                }, null, 8, ["endTimestamp", "isInitialized"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})